import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { OfflineBanner } from '@/components/OfflineBanner';
import { SyncIndicator } from '@/components/SyncIndicator';
import { InstallPrompt } from '@/components/InstallPrompt';
import { cn } from '@/lib/utils';

interface AppShellProps {
  title: string;
  showBack?: boolean;
  rightSlot?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function AppShell({ title, showBack, rightSlot, children, className }: AppShellProps) {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-full flex-col">
      <OfflineBanner />
      <header className="pt-3-safe sticky top-0 z-30 flex items-center gap-3 border-b border-brand-border bg-brand-bg/95 px-3 pb-3 backdrop-blur">
        {showBack && (
          <button
            type="button"
            aria-label="Back"
            onClick={() => navigate(-1)}
            className="rounded p-2 hover:bg-brand-surface"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
        )}
        <h1 className="flex-1 text-lg font-bold">{title}</h1>
        {rightSlot ?? <SyncIndicator />}
      </header>
      <main className={cn('flex-1 px-3 py-4', className)}>{children}</main>
      <InstallPrompt />
    </div>
  );
}
